<div class="filter-component">
  <!-- Status Filter -->
  <button
    class="expansion-filter"
    mat-menu-item
    #statusTarefaTrigger="matMenuTrigger"
    [matMenuTriggerFor]="statusTarefa"
  >
    <div class="expansion-div">
      <ng-icon name="heroChevronLeftMini" class="icon-expansion" />
      <span class="filter-text"
        >Status
        <ng-container *ngIf="getStatusCount() as cnt">
          ({{ cnt }})
        </ng-container></span
      >
    </div>
  </button>

  <mat-menu #statusTarefa="matMenu" class="container-menu" xPosition="before">
    <sub-filtro-status-tarefa
      [listaStatusTarefa]="listaStatusTarefa"
      [statusSelecionado]="status"
      (atualizaFiltroStatusTarefa)="onChangeStatus($event)"
    ></sub-filtro-status-tarefa>
  </mat-menu>

  <!-- Período de Previsão de Conclusão Filter -->
  <button
    class="expansion-filter"
    mat-menu-item
    #periodoTarefaTrigger="matMenuTrigger"
    [matMenuTriggerFor]="periodoTarefa"
  >
    <div class="expansion-div">
      <ng-icon name="heroChevronLeftMini" class="icon-expansion" />
      <span class="filter-text"
        >Período de Previsão de Conclusão
        <ng-container *ngIf="getPeriodoCount() as cnt">
          ({{ cnt }})
        </ng-container></span
      >
    </div>
  </button>

  <mat-menu #periodoTarefa="matMenu" class="container-menu" xPosition="before">
    <sub-filtro-periodo-tarefa
      [listaPeriodoTarefa]="listaPeriodoTarefa"
      [periodoSelecionado]="period"
      (atualizaFiltroPeriodoTarefa)="onChangePeriod($event)"
    ></sub-filtro-periodo-tarefa>
  </mat-menu>

  <!-- Responsáveis Filter -->
  <button
    class="expansion-filter"
    mat-menu-item
    #usuariosTrigger="matMenuTrigger"
    [matMenuTriggerFor]="usuariosMenu"
  >
    <div class="expansion-div">
      <ng-icon name="heroChevronLeftMini" class="icon-expansion" />
      <span class="filter-text">
        Responsáveis

        @if (usuariosID.length) {
          ({{usuariosID.length}})
        }
      </span>
    </div>
  </button>

  <mat-menu #usuariosMenu="matMenu" class="container-menu" xPosition="before">
    <sub-filtro-usuarios
      [listaUsuarios]="listaUsuarios"
      [(filtroUsuario)]="usuariosID"
      (filtroUsuarioChange)="onChangeUser($event)"
    ></sub-filtro-usuarios>l
  </mat-menu>
</div>